module.exports = __webpack_public_path__ + "assets/asian_active-47e1c9.svg";